var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIconLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16101",
    "data-name": "Rectangle 16101",
    width: 42.629,
    height: 42.677,
    fill: "#f54e30"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15675",
    "data-name": "Group 15675",
    transform: "translate(-1257 1926)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_688",
    "data-name": "Ellipse 688",
    cx: 49,
    cy: 49,
    r: 49,
    transform: "translate(1257 -1926)",
    fill: "#fed3cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15467",
    "data-name": "Group 15467",
    transform: "translate(1306.177 -1907) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15411",
    "data-name": "Group 15411",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41212",
    "data-name": "Path 41212",
    d: "M32.28,25.873H26.321c-.469,0-.47,0-.47.483,0,3.886.007,7.771,0,11.657a4.377,4.377,0,0,1-2.732,4.277,4.533,4.533,0,0,1-6.136-2.784,5.557,5.557,0,0,1-.208-1.591c-.017-3.876-.01-7.752-.011-11.627,0-.421,0-.417-.421-.417-3.953,0-7.907.009-11.86,0A4.544,4.544,0,0,1,2.861,17.1a5.028,5.028,0,0,1,1.69-.3c3.953-.025,7.906-.013,11.86-.012.346,0,.356-.009.356-.4q0-5.872-.007-11.745a4.455,4.455,0,0,1,1.465-3.457,4.547,4.547,0,0,1,7.461,2.165,5.216,5.216,0,0,1,.157,1.3c.011,3.905,0,7.81,0,11.715,0,.414,0,.414.43.414,3.846,0,7.691.007,11.537,0a4.682,4.682,0,0,1,3.095.969,4.35,4.35,0,0,1,1.667,4.212,4.321,4.321,0,0,1-3.407,3.78,4.739,4.739,0,0,1-1.191.123c-1.9.012-3.8.005-5.7.006",
    transform: "translate(0 0)",
    fill: "#f54e30"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconLarge);
export default __webpack_public_path__ + "static/media/close-icon-large.e654087d9dacbba395df81c862db2d06.svg";
export { ForwardRef as ReactComponent };